exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\n.canopy-list-renderer.offer-renderer {\n  border-bottom: 1px solid #e0e0e0; }\n.canopy-list-renderer.offer-renderer .mat-line {\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-bottom: 0 !important; }\n.fav-drag-handle {\n  position: initial; }\nperfect-scrollbar {\n  width: 100%;\n  height: calc(100vh - (75px + 100px + 138px)); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-editor/favourite-list/favourite-list.component.scss
// module id = ../../../../../src/app/shared/components/offer-editor/favourite-list/favourite-list.component.scss
// module chunks = main